import { PopupLocationMarker } from '@/components/PopupLocationMarker'

import type { FC } from 'react'

interface BusinessNameLocationMarkerProps {
	latitude: number
	longitude: number
	name?: string
}

export const BusinessNameLocationMarker: FC<BusinessNameLocationMarkerProps> = ({
	name,
	...coordinates
}) => {
	return (
		<PopupLocationMarker coordinates={coordinates}>
			{name && <div className="text-sm font-medium p-2 bg-background rounded-xl">{name}</div>}
		</PopupLocationMarker>
	)
}
